// extracted by mini-css-extract-plugin
export default {"root":"VerifyLoginForm_root__F+BoD","codeInput":"VerifyLoginForm_codeInput__pQAdW"};